"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReturnInstructionsStepsContainer = exports.ReturnInstructionsTitle = exports.PopoverCloseButtonContainer = exports.FreeReturnsPolicyPopoverContainer = exports.FreeReturnsPolicyDescriptionUL = exports.FreeReturnsPolicyPrimaryMessage = exports.FreeReturnsPolicyPrimaryMessageContainer = exports.FreeReturnsPolicyContainer = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const monera_app_core_1 = require("@amzn/monera-app-core");
const canvas_box_1 = require("../canvas-box");
const themed_text_1 = require("../themed-text");
const setMaxWidth = (props) => {
    const maxWidth = props.mobileView ? '' : 'max-width: 280px;';
    return (0, styled_components_1.css) `
    ${maxWidth};
  `;
};
exports.FreeReturnsPolicyContainer = styled_components_1.default.div `
  position: relative;
  font-family: ${(props) => props.theme.typography.base.fontFamily};
  color: ${(props) => props.theme.palettes.font.base};
`;
exports.FreeReturnsPolicyPrimaryMessageContainer = (0, styled_components_1.default)(canvas_box_1.CanvasContainer) `
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  &:hover {
    color: ${monera_app_core_1.rioTextColors.linkHover};
  }
`;
exports.FreeReturnsPolicyPrimaryMessage = (0, styled_components_1.default)(themed_text_1.ThemedSpan) `
  && {
    &:hover {
      color: ${monera_app_core_1.rioTextColors.linkHover};
    }
  }
`;
exports.FreeReturnsPolicyDescriptionUL = styled_components_1.default.ul `
  margin: 0;
  color: ${(props) => props.theme.palettes.font.base};
`;
exports.FreeReturnsPolicyPopoverContainer = styled_components_1.default.div `
  z-index: 299;
  visibility: visible;
  width: 100%;
  ${setMaxWidth}
`;
exports.PopoverCloseButtonContainer = styled_components_1.default.div `
  position: absolute;
  top: 5px;
  right: 15px;
`;
exports.ReturnInstructionsTitle = styled_components_1.default.div `
  color: ${monera_app_core_1.Blue_400};
  font-size: ${(props) => props.theme.typography.base.fontSize};
  cursor: pointer;
  &:hover {
    color: ${monera_app_core_1.rioTextColors.linkHover};
    text-decoration: underline;
  }
`;
exports.ReturnInstructionsStepsContainer = styled_components_1.default.div `
  margin-top: 4px;
  padding-left: 15px;
  color: ${(props) => props.theme.palettes.font.base};
`;
